import React, { useState } from "react";
import Modal from "../../common/Modal/Modal";
import Checkbox from "@mui/material/Checkbox";
import isAnyChecked from "./Utils/IsAnyChecked";
import checkboxData from "./Utils/Checkboxes";

// Import Download Functionalities
import handleDownloadTextReportPDF from "./Utils/DownloadFunctionalities/DownloadTextReportPDF";
import handleDownloadCSV from "./Utils/DownloadFunctionalities/DownloadCSV";

import "./downloadReport.css";

export default function DownloadReport() {
  // Report Array UseStates
  const [checkboxStates, setCheckboxStates] = useState({
    selectTextualReport: false,
    selectCSVInputData: false,
  });

  // Modal UseStates
  const [openModal, setOpenModal] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [selectedReports, setSelectedReports] = useState([]);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setIsError(false);
    setIsSuccess(false);
  };

  const handleCheckboxChange = (checkboxId, reportName) => {
    setCheckboxStates({
      ...checkboxStates,
      [checkboxId]: !checkboxStates[checkboxId],
    });

    setSelectedReports((selectedReports) => {
      if (checkboxStates[checkboxId]) {
        return selectedReports.filter((report) => report !== reportName);
      } else {
        return [...selectedReports, reportName];
      }
    });
  };

  const anyCheckboxChecked = isAnyChecked(
    checkboxStates.selectTextualReport,
    checkboxStates.selectCSVInputData
  );

  const handleDownloadClick = async () => {
    const downloadFunctions = {
      selectTextualReport: handleDownloadTextReportPDF,
      selectCSVInputData: handleDownloadCSV,
    };

    const successResults = [];
    const errorResults = [];

    for (const checkboxId in checkboxStates) {
      if (checkboxStates[checkboxId]) {
        const downloadFunction = downloadFunctions[checkboxId];
        if (downloadFunction) {
          try {
            await downloadFunction(checkboxStates);
            successResults.push(checkboxId);
          } catch (error) {
            errorResults.push(checkboxId);
          }
        }
      }
    }

    if (errorResults.length > 0) {
      setIsError(true);
      setIsSuccess(false);
    } else if (successResults.length > 0) {
      setIsSuccess(true);
      setIsError(false);
    }

  };

  const generateSuccessMessage = (selectedReports) => {
    if (selectedReports.length === 1) {
      return `You have successfully downloaded ${selectedReports[0]}`;
    } else {
      return "You have successfully downloaded your reports!";
    }
  };

  return (
    <>
      <button
        className={`orange-button-download ${anyCheckboxChecked ? "active" : ""}`}
        onClick={handleOpenModal}
      >
        Download
      </button>
      <Modal
        isOpen={openModal}
        onClose={handleCloseModal}
        title={isError ? "Error Generating Report" : "Download Files"}
        showCustomContent={true}
        customContent={
          isSuccess ? (
            <div>
              <div className="modal-success-container">
              <div className="icon-container">
                <i className="fas fa-check" />
              </div>
              <div className="download-success-message">
                {generateSuccessMessage(selectedReports)}
              </div>
              </div>
              <div className="savemodal-btn-container">
              <button className="button-close" onClick={handleCloseModal}>
                Okay
              </button>
              </div>
            </div>
          ) : isError ? (
            <div>
            <div className="modal-error-container">
              <div className="savesubmitmodal-description">
              There was a problem completing your download. Please try again or email contact@hecoanalytics.com if the issue persists.
              </div>
              <div className="savemodal-btn-container">
              <button className="button-close" onClick={handleCloseModal}>
                Done
              </button>
              </div>
              </div>
            </div>
          ) : (
            <>
              <div className="report-modal-container">
                <div className="report-modal-description">
                  Select the files you would like to download.
                </div>
              </div>
              <div className="check-box-container">
                {checkboxData.map((checkbox) => (
                  <div className="check-box-item" key={checkbox.id}>
                    <div className="check-box-icon-wrapper">
                    <input
                        type="checkbox"
                        id={checkbox.id}
                        checked={checkboxStates[checkbox.id]}
                        onChange={() =>
                          handleCheckboxChange(checkbox.id, checkbox.label)
                        }
                       
                      />
                    </div>
                    <label
                      htmlFor={checkbox.id}
                      className="check-box-text"
                    >
                      {checkbox.label}
                    </label>
                  </div>
                ))}
              </div>
              <div className="download-button-container">
                <button
                  className={`download-button ${
                    anyCheckboxChecked ? "active" : ""
                  }`}
                  onClick={handleDownloadClick}
                >
                  Download
                </button>
              </div>
            </>
          )
        }
      />
    </>
  );
}
